import Vue from 'vue'
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        currentRouteName: null,
        editingTestData: {
            editingTestId: null,
            editingTestType: null,
        },
        testContentId: null,
        currentUser: null,
        userPermissions: [],
        currentCourseId: null,
        currentTopicId: null,
        currentSectionId: null,
        questionLevel: null,
        updateCurrentTopicId: null,
        updateCurrentSectionId: null,
        updateQuestionLevel: null,
        teacherFilesModalShow: false,
        subjectList: [],
        classList: [
            {
                id: 1,
                name: '1 - sinf'
            },
            {
                id: 2,
                name: '2 - sinf'
            },
            {
                id: 3,
                name: '3 - sinf'
            },
            {
                id: 4,
                name: '4 - sinf'
            },
            {
                id: 5,
                name: '5 - sinf'
            },
            {
                id: 6,
                name: '6 - sinf'
            },
            {
                id: 7,
                name: '7 - sinf'
            },
            {
                id: 8,
                name: '8 - sinf'
            },
            {
                id: 9,
                name: '9 - sinf'
            },
            {
                id: 10,
                name: '10 - sinf'
            },
            {
                id: 11,
                name: '11 - sinf'
            }
        ],
        languages: [
            {
                id: 1,
                name: 'O`zbek'
            },
            {
                id: 2,
                name: 'Rus'
            },
            {
                id: 3,
                name: 'Qoraqalpoq'
            },
            {
                id: 4,
                name: 'Qozoq'
            },
            {
                id: 5,
                name: 'Turkman'
            },
            {
                id: 6,
                name: 'Qirg`iz'
            },
        ],
        questionLevels: []
    },
    mutations: {
        setSubjectList: (state, data) => state.subjectList = data,
        setQuestionLevels: (state, data) => state.questionLevels = data,
        setCurrentRouteName(state, currentRoute) {
            state.currentRouteName = currentRoute;
        },
        setCourseSkillId(state, skillId) {
            state.courseSkillId = skillId;
        },
        commitEditingTestId(state, testId) {
            state.editingTestData.editingTestId = testId;
        },
        commitEditingTestType(state, type) {
            state.editingTestData.editingTestType = type;
        },
        commitTestContentId(state, contentId) {
            state.testContentId = contentId;
        },
        commitCurrentUser(state, user) {
            state.currentUser = user;
        },
        commitUserPermissions(state, permissions) {
            state.userPermissions = [];
            state.userPermissions = permissions
        },
        commitCurrentCourseId(state, currentCourseId) {
            state.currentCourseId = currentCourseId
        },
        commitCurrentTopicId(state, currentTopicId) {
            state.currentTopicId = currentTopicId
        },
        commitCurrentSectionId(state, currentSectionId) {
            state.currentSectionId = currentSectionId
        },
        commitQuestionLevel(state, questionLevel) {
            state.questionLevel = questionLevel
        },
        updateCommitCurrentTopicId(state, currentTopicId) {
            state.updateCurrentTopicId = currentTopicId
        },
        updateCommitCurrentSectionId(state, currentSectionId) {
            state.updateCurrentSectionId = currentSectionId
        },
        updateCommitQuestionLevel(state, questionLevel) {
            state.updateQuestionLevel = questionLevel
        },
        setTeacherFilesModalShow: (state, booleanState) => state.teacherFilesModalShow = booleanState,
    },
    getters: {
        subjectList: state => state.subjectList,
        questionLevels: state => state.questionLevels,
        classList: state => state.classList,
        languages: state => state.languages,
        teacherFilesModalShow: state => state.teacherFilesModalShow,
        getEditingTestData: state => {
            return state.editingTestData;
        },
        getQuestionProperties: state => {
            let object = {};
            object.topic = state.updateCurrentTopicId;
            object.subject = state.updateCurrentSectionId;
            object.questionLevel = state.updateQuestionLevel;
            return object;
        }
    },
    actions: {
        async getSubjectList({commit}) {
            try {
                await this._vm.$api.get('admin/AbitTest/SubjectList').then(data => {
                    if (!data.error && data.result) {
                        commit('setSubjectList', data.result);
                    }
                }).catch(error => {
                    console.log('Error on getting subject list' + error)
                }).finally(() => {
                })
            } catch (e) {
                console.log(e)
            }
        },
        async getQuestionLevels({commit}) {
            try {
                await this._vm.$api.get('main/Home/Test/LevelList').then(data => {
                    if (!data.error && data.result) {
                        commit('setQuestionLevels', data.result);
                    }
                }).catch(error => {
                    console.log('Error on getting question levels list' + error)
                }).finally(() => {
                })
            } catch (e) {
                console.log(e)
            }
        },
    }
});
export default store;
